import React from "react";

import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

export default class Heartbeat extends React.Component {
  componentDidMount() {
    this.intervalID = setInterval(
      () => {
        fetchWithCSRFToken("/heartbeat", { method: "POST" });
      },
      5 * 60 * 1000,
    ); // One heartbeat every 5 minutes.
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    return null;
  }
}
